var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPristynCareLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 195.991,
    height: 46,
    viewBox: "0 0 195.991 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f7be00;}.b{fill:#965ec7;}.c{fill:#3d7cc9;}.d{fill:#ff8300;}.e{fill:#ffffff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-179.344 -225.106)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.344 225.106)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.743)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M218.04,225.1v15.945c.058,0,.114.009.173.009a15.781,15.781,0,0,0,15.78-15.781c0-.058-.008-.114-.009-.173Z",
    transform: "translate(-218.04 -225.096)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M233.993,302.442c-.058,0-.114-.009-.173-.009a15.781,15.781,0,0,0-15.78,15.781c0,.058.008.114.009.173h15.944Z",
    transform: "translate(-218.04 -272.386)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15.013)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M179.344,279.691h15.945c0-.058.009-.114.009-.173a15.78,15.78,0,0,0-15.78-15.78c-.058,0-.115.008-.173.009Z",
    transform: "translate(-179.344 -263.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M256.744,263.738c0,.058-.009.114-.009.173a15.78,15.78,0,0,0,15.78,15.781c.058,0,.115-.008.173-.009V263.738Z",
    transform: "translate(-227.25 -263.738)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(238.627 238.18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M325.609,280.231V263.724c2.358-.024,4.693,0,7.051,0a5.7,5.7,0,0,1,5.872,6.013,5.617,5.617,0,0,1-5.872,5.825h-3.514v4.669Zm7.051-7.688a2.652,2.652,0,0,0,2.5-2.9,2.587,2.587,0,0,0-2.5-2.83c-1.2-.024-2.382,0-3.585,0v5.73Z",
    transform: "translate(-325.609 -263.581)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M367.784,275.594a3.946,3.946,0,0,1,2.429.731l-.731,2.759a3.576,3.576,0,0,0-2.122-.613,2.541,2.541,0,0,0-2.665,2.688v6.155h-3.231V279.3c0-.943-.094-1.556-1.132-1.391v-2.028c1.651-.377,4.08-.377,4.268,1.651A3.212,3.212,0,0,1,367.784,275.594Z",
    transform: "translate(-346.244 -270.641)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M389.072,263.738a1.9,1.9,0,1,1-1.981,1.887A1.826,1.826,0,0,1,389.072,263.738Zm1.6,16.531h-3.3V269.044h3.3Z",
    transform: "translate(-362.145 -263.596)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M403.743,283.919c.024.943.92,1.367,1.863,1.344.967,0,1.934-.283,1.957-1.3,0-.92-.825-1.014-1.627-1.132-2.288-.307-5.259-.613-5.259-3.372,0-2.547,2.1-3.749,4.881-3.749,2.712,0,5.046,1.227,4.928,3.632h-3.113c-.024-.825-.825-1.155-1.769-1.155s-1.745.424-1.745,1.179c0,.849.9.967,1.627,1.038,2.547.307,5.447.519,5.376,3.561-.071,2.712-2.547,3.726-5.117,3.726s-5.188-.755-5.306-3.773Z",
    transform: "translate(-370.079 -270.712)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M433.54,271.345h3.7v2.476h-3.7v4.41c0,2.358,1.958,2.476,3.844,1.793l.306,2.5c-3.914,1.085-7.381.448-7.381-4.221v-4.48l-2.146-.212v-2.264h2.382l.354-3.537h2.641Z",
    transform: "translate(-386.554 -266.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M460.741,288.943c-1.439,3.7-2.924,5.66-7.051,4.15l.354-2.288c1.863.826,2.83.118,3.49-1.769l.424-1.179-4.976-11.013v-.377h3.467l1.533,3.844,1.485,4.2h.071l1.3-4.174,1.367-3.867h3.349v.377Z",
    transform: "translate(-401.302 -271.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M495.449,287.454v-6.579a2.141,2.141,0,0,0-2.146-2.429,2.365,2.365,0,0,0-2.405,2.5v6.508h-3.3V279.6c0-1.132,0-1.486-1.085-1.486v-2.051c1.509-.26,4.151-.519,4.151,1.533.637-1.321,2.311-1.769,3.631-1.769,3.207,0,4.481,2.217,4.481,5.047v6.579Z",
    transform: "translate(-421.228 -270.781)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M544.939,263.389c3.325,0,6.862,1.792,7.616,5.872h-3.419a4.113,4.113,0,0,0-4.2-2.688c-2.924,0-4.882,2.122-4.882,5.259a4.887,4.887,0,0,0,4.858,5.188,4.11,4.11,0,0,0,4.292-2.972h3.4c-.707,4.363-4.221,6.179-7.664,6.179-4.339,0-8.442-2.924-8.442-8.4A8.084,8.084,0,0,1,544.939,263.389Z",
    transform: "translate(-450.932 -263.388)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M583.01,287.632a3.863,3.863,0,0,1-4.127-3.561c-.118-2.783,1.887-4.1,4.41-4.1a5.786,5.786,0,0,1,3.019.731v-.779c0-1.391-1.7-1.627-2.83-1.627a6.556,6.556,0,0,0-3.278.684l-.425-2.358a10.291,10.291,0,0,1,4.268-.849c2.924,0,5.424.967,5.424,4.245v4.1c0,.967-.024,1.533,1.061,1.462l.024,1.839c-1.721.377-3.608.283-3.608-1.745C586.264,287.089,584.472,287.632,583.01,287.632Zm3.23-4.881a4.287,4.287,0,0,0-2.358-.66c-1.038.071-1.887.66-1.769,1.769a1.422,1.422,0,0,0,1.556,1.226c1.085,0,2.452-.542,2.57-1.745Z",
    transform: "translate(-476.117 -270.746)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M617.054,275.594a3.946,3.946,0,0,1,2.429.731l-.731,2.759a3.573,3.573,0,0,0-2.122-.613,2.541,2.541,0,0,0-2.665,2.688v6.155h-3.231V279.3c0-.943-.094-1.556-1.132-1.391v-2.028c1.651-.377,4.08-.377,4.268,1.651A3.212,3.212,0,0,1,617.054,275.594Z",
    transform: "translate(-494.375 -270.641)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M645.88,282.42h-7.711c.118,1.768,1.439,2.452,3.019,2.57a8.073,8.073,0,0,0,1.509-.024,9.885,9.885,0,0,0,2.712-.684l.377,2.405a10.5,10.5,0,0,1-4.41,1.014c-3.82.071-6.509-2.264-6.509-6.108a5.642,5.642,0,0,1,5.966-5.825C644.984,275.77,646.752,278.553,645.88,282.42Zm-7.687-2.122h5c.071-1.486-1.132-2-2.358-2A2.53,2.53,0,0,0,638.192,280.3Z",
    transform: "translate(-509.389 -270.746)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPristynCareLogoLight);
export default __webpack_public_path__ + "static/media/pristyn-care-logo (Light).9b1b3db54ee5a990bbbb68542ecaa07e.svg";
export { ForwardRef as ReactComponent };